const resources = {
    title: 'Check Your Email',
    clickVerificationLink1: 'Please click the verification link we sent to your email',
    clickVerificationLink2: 'to set up your account',
    didntGetIt: 'Didn’t get it? Check your spam folders or',
    resend: 'resend',
    confirmButton: 'OK',
    emailResent: 'Email successfully resent.',
    emailResentError: 'Something went wrong, and we could not resend the email. Please try again later or resend the email.',
    tokenValidationError: 'The link for verifying your account has expired or is invalid. Please resend the email to get a new link.',
    error: 'Error',
    success: 'Success'
};

module.exports = function getResource(label, vars = []) {
    return resources[label];
};
